// 261015 — "Gỡ khoá" việc nền bị treo (pod chết lúc deploy ⇒ job kẹt FILM_RUNNING tới 120′). Một link ở dải đầu trang → hộp liệt kê job đang chạy,
// mỗi job một nút "Gỡ khoá" có xác nhận. Gỡ = đánh job FAILED ở server; KHÔNG dừng được job thật còn chạy.
import React, { useState } from 'react';
import { Modal, Popconfirm, Space, Typography, message } from 'antd';
import Button from './WbButton';
import { filmApi } from '../../../services/api/film';
import type { WorkbenchRunningJob } from '../../../types/adaptationWorkbench';
import { friendlyApiError } from './jobErrorText';
import { jobKindLabel } from './workbenchView';

const { Text } = Typography;

export const RELEASE_CONFIRM_TEXT = 'Chỉ dùng khi chắc job đã chết (vd. server vừa deploy / khởi động lại). Job thật còn chạy sẽ KHÔNG bị dừng và có thể ghi đè kết quả sau khi gỡ.';

const ReleaseJobsLink: React.FC<{ jobs: WorkbenchRunningJob[]; onReleased: () => void | Promise<unknown> }> = ({ jobs, onReleased }) => {
  const [open, setOpen] = useState(false);
  const [busyId, setBusyId] = useState<string | null>(null);
  if (jobs.length === 0) return null;

  const release = async (jobId: string) => {
    setBusyId(jobId);
    try {
      await filmApi.releaseFilmJob(jobId);
      message.success('Đã gỡ khoá job.');
    } catch (e: any) {
      // 409 NOT_RUNNING = job vừa xong / đã được gỡ ở nơi khác: vẫn làm mới danh sách.
      message.warning(friendlyApiError(e, 'Không gỡ được khoá'));
    } finally {
      setBusyId(null);
      await onReleased();
    }
  };

  return (
    <>
      <Button size="small" type="link" onClick={() => setOpen(true)}>Gỡ khoá…</Button>
      <Modal open={open} onCancel={() => setOpen(false)} footer={null} title="Việc nền đang chạy" destroyOnClose>
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
          <Text type="secondary">{RELEASE_CONFIRM_TEXT}</Text>
          {jobs.map((j) => (
            <div key={j.jobId} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ flex: 1 }}>
                {jobKindLabel(j.kind)}{j.phase ? ` / ${j.phase}` : ''} · <Text code>{j.jobId.slice(0, 8)}</Text>
                {j.startedAt ? ` · chạy từ ${new Date(j.startedAt).toLocaleTimeString()}` : ''}
              </span>
              <Popconfirm title="Gỡ khoá job này?" description={RELEASE_CONFIRM_TEXT} okText="Gỡ khoá" cancelText="Thôi" okButtonProps={{ danger: true }}
                onConfirm={() => release(j.jobId)}>
                <Button size="small" danger loading={busyId === j.jobId}>Gỡ khoá</Button>
              </Popconfirm>
            </div>
          ))}
        </Space>
      </Modal>
    </>
  );
};

export default ReleaseJobsLink;
